import type { Account } from '@interfaces/account';

import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Card, CardContent } from '@ovComponents/2-component/card/card';

import { BeneficiaryTable } from '@ovComponents/3-pattern/beneficiaryCrud/beneficiaryTable';
import { GoalLinkingReview } from '@ovComponents/4-module/workflowCompletion/subSteps/account/goalLinking';
import { getJointAffiliate } from '@ovComponents/4-module/workflowCompletion/subSteps/account/utils';
import { Box, IconButton, Typography } from 'hephaestus/web';
import { CloseRounded as CloseRoundedIcon } from 'hephaestus/webIcons';
import React from 'react';
import { useTranslation } from 'react-i18next';

type JointCashReviewItemProps = {
  account: Account;
  onDeleteAccount: (account?: Account) => void;
};
export const JointCashReviewItem = ({
  account,
  onDeleteAccount,
}: JointCashReviewItemProps) => {
  const { t } = useTranslation([
    'affiliationTypes',
    'shared',
    'workflowCompletions',
  ]);
  const jointAffiliate = getJointAffiliate(account);

  return (
    <Card variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pl: 0.9,
          }}
        >
          <Typography variant='bodyLarge' sx={{ fontWeight: 600, mt: 1 }}>
            {t('workflowCompletions:accountReviewPanel.jointCash')}
          </Typography>
          {account.id ? undefined : (
            <IconButton aria-label='close' onClick={() => onDeleteAccount()}>
              <Icon icon={CloseRoundedIcon} size='small' />
            </IconButton>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            mb: 1,
            px: 1,
          }}
        >
          <Typography variant='labelLarge' sx={{ fontWeight: 600 }}>
            {`${t('workflowCompletions:jointAccountHolder.label')}:`}
          </Typography>
          <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
            {jointAffiliate ? t('shared:yes') : t('shared:no')}
          </Typography>
        </Box>
        {jointAffiliate && (
          <BeneficiaryTable
            beneficiaries={[jointAffiliate]}
            hideAllocation={true}
            allowDelete={false}
          />
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 1,
            px: 1,
          }}
        >
          <GoalLinkingReview account={account} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default JointCashReviewItem;
